import { gReactive } from '@gradin/vue-utils'
import { ref } from 'vue'
import { useApi } from '@/functions/api'
import { toast } from '@/stores/toast'

export function useBuybackList () {
  const api = useApi()

  const buybacks = ref<BuybackList[]>([])
  const pagination = ref<Pagination>()
  const loading = ref(false)

  const getData = async (params: object) => {
    try {
      loading.value = true
      const response = await api.GET<ApiCollection<BuybackList>>('admin/buyback', params)
      buybacks.value = response.data
      pagination.value = response.meta
    } finally {
      loading.value = false
    }
  }

  return {
    buybacks,
    pagination,
    loading,
    getData,
  }
}

export function useBuybackDetail () {
  const api = useApi()

  const buyback = ref<BuybackDetail>()
  const loading = ref(false)

  const getData = async (id: number) => {
    try {
      loading.value = true
      const response = await api.GET<BuybackDetail>(`admin/buyback/${id}`)
      buyback.value = response
      return response
    } finally {
      loading.value = false
    }
  }

  return {
    buyback,
    loading,
    getData,
  }
}

export function useBuybackUpdate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const buyback = ref<BuybackDetail>()
  const form = gReactive({
    buy_back_items: [] as string[],
  })

  const submitForm = async (id: number) => {
    try {
      submitting.value = true
      const response = await api.PUT<BuybackDetail>(`admin/buyback/${id}`, form)
      buyback.value = response
      toast.dataSaved()
      return response
    } catch (error) {
      errors.value = api.formErrors(error)
      return null
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    form,
    buyback,
    submitForm,
  }
}

export function useBuybackCreate () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})
  const buyback = ref<BuybackDetail>()
  const form = gReactive({
    buy_back_items: [] as string[],
  })

  const submitForm = async () => {
    try {
      submitting.value = true
      const response = await api.POST<BuybackDetail>('admin/buyback', form)
      buyback.value = response
      toast.dataSaved()
      return response
    } catch (error) {
      errors.value = api.formErrors(error)
      return null
    } finally {
      submitting.value = false
    }
  }

  return {
    submitting,
    errors,
    form,
    buyback,
    submitForm,
  }
}

export function useBuybackDelete () {
  const api = useApi()
  const submitting = ref(false)
  const errors = ref<FormError>({})

  const submitDelete = async (id: number) => {
    try {
      submitting.value = true
      await api.DELETE(`admin/buyback/${id}`)
      return id
    } catch (error) {
      errors.value = api.formErrors(error)
      return null
    } finally {
      submitting.value = false
    }
  }

  return {
    errors,
    submitting,
    submitDelete,
  }
}

